export const CHEMICAL_ELEM_NUM = 118;